import { useEffect, useState } from 'react';
import { Button as ChakraButton, Flex } from '@chakra-ui/react';
import { useGetCelloTokenQuery } from 'src/generated/graphql';
import { useUserCache } from 'src/apollo/cache';
import fonts from 'src/theme/fonts';
import hexToRgb from 'src/utils/hexToRgb';
import colors from 'src/theme/colors';
import { useMenuContext } from '../../MenuContext';
import Icons from '../../Icons';

export default function CelloLaunchButton() {
  const user = useUserCache();
  const [menuState] = useMenuContext();
  const [celloReady, setCelloReady] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { data } = useGetCelloTokenQuery({ fetchPolicy: 'network-only' });

  useEffect(() => {
    const initializeCello = async () => {
      if (celloReady) return;
      try {
        // Generate the JWT token from the backend

        if (data?.getCelloToken) {
          const { token, productId } = data.getCelloToken;
          // @ts-ignore
          window.cello = window.cello || { cmd: [] };
          // @ts-ignore
          window.cello.cmd.push(async (cello: any) => {
            await cello.boot({
              productId,
              token,
              language: 'en',
              productUserDetails: {
                firstName: user?.firstName,
                email: user?.email,
              },
            });
          });

          setCelloReady(true);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error initializing Cello:', error);
      }
    };

    initializeCello();
  }, [celloReady, data?.getCelloToken, user?.email, user?.firstName]);

  if (!celloReady) {
    return null;
  }

  const sharedProps = {
    color: colors.white,
    borderRadius: '12px',
    _active: { bg: colors.white, color: hexToRgb(colors.podcastPurple800, 0.8) },
  };

  if (menuState === 'closed') {
    return (
      <ChakraButton
        bg={colors.podcastPurple800}
        visual="flat"
        w={isHovered ? '100%' : '48px'}
        height="48px"
        aria-label="Refer & Earn $25"
        fontFamily={fonts.bold}
        textTransform="capitalize"
        transitionDuration="150ms"
        zIndex={20}
        alignItems="center"
        {...sharedProps}
        _hover={{
          boxShadow: '0px 2px 6px rgb(101 85 205 / 30%)',
        }}
        paddingLeft={isHovered ? '10px' : '32px'}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        id="cello-launcher"
      >
        <Flex w="28px" justifyContent="center" flexShrink={0}>
          <Icons.ReferFriend color="white" />
        </Flex>
        {isHovered ? 'Refer & Earn $25' : null}
      </ChakraButton>
    );
  }

  return (
    <ChakraButton
      bg="transparent"
      visual="flat"
      fontFamily={fonts.bold}
      justifyContent="flex-start"
      textTransform="capitalize"
      w="100%"
      height="48px"
      px="15px"
      transitionDuration="150ms"
      zIndex={20}
      alignItems="center"
      fontSize="16px"
      {...sharedProps}
      _hover={{
        boxShadow: '0px 2px 6px rgb(101 85 205 / 30%)',
        bg: hexToRgb(colors.white, 0.1),
      }}
      id="cello-launcher"
      position="relative" // needed for cello
      css={{
        '& > div:not(.icon)': {
          // cello adds two empty divs which breaks the flexbox styling. Making them position absolute prevents them breaking the layout
          position: 'absolute',
        },
      }}
    >
      <Flex w="28px" justifyContent="center" className="icon">
        <Icons.ReferFriend color="white" />
      </Flex>
      Refer & Earn $25
    </ChakraButton>
  );
}
